@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/spacing.module.less';

.label {
  padding-right: 10px;
  text-align: right;
  max-width: 100px;
  padding-top: 10px;
  cursor: pointer;
}

.insurance-container-group {
  display: flex;
  align-items: center;
}

.insurance-amount {
  height: 32px;

  input {
    line-height: unset;
    padding-top: 10px;
    padding-bottom: 10px;

    &:focus {
      border-color: @fulfillment-planner--insurance-input--focus--border-color;
    }
  }

  &.checkbox-input {
    max-width: 96px;
  }
}

.insurance-checkbox {
  padding-right: @space-12;
}

.insurance-not-available {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  grid-column-start: 2;
  color: var(--grey-600);
}

.alert {
  grid-column-start: 2;
  min-width: 245px;
}

.icon {
  height: 16px;
  width: 16px;
  margin-right: 4px;

  &.high-value-icon {
    color: var(--blue-600);
  }

  &.maximum-coverage-icon {
    color: var(--gold-500);
  }
}
